import { apiPathFunc } from "@api/util/apiPathFunc";

import { exportExcel } from "./exportExcel/path";
import { exportPDF } from "./exportPDF/path";
import { settle } from "./settle/path";

import type { IExtractParams } from "@routes";

const pathBase = `/installments/`;
const pathById = `${pathBase}:installmentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const installments = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  settle,
  exportPDF,
  exportExcel,
};
